export default function Footer() {
  return (
    <footer className="mx-auto bg-primary-bg py-7 sm:w-5xl lg:mb-8 lg:w-full lg:max-w-440">
      <div className="mx-6 flex justify-between border-t-2 border-slate-600 pt-5 text-sm text-white sm:mx-10 lg:mx-6">
        © Commerce Decisions
        <a
          className="cursor-pointer"
          href="https://commercedecisions.com/policies-terms/privacy-policy-2/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Policies & Terms
        </a>
      </div>
    </footer>
  );
}
